import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { UnitsService } from 'src/app/services/units.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { MainService } from 'src/app/services/main.service';
import { ClientsService } from 'src/app/services/clients.service';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { ViewRfidComponent } from '../view-rfid/view-rfid.component';
import { DeletRfidComponent } from '../delet-rfid/delet-rfid.component';
import { EditRFIDComponent } from '../edit-rfid/edit-rfid.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';


@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.css']
})
export class EditClientComponent implements OnInit {
  validForm = true;
  unitId: any;
  clientId: any;
  clientForm: FormGroup | any;
  RfidForm: FormGroup | any;
  types_arr: any;
  typeName: any = 'Relation type';
  typeId: any = '';
  submitted = false;
  userPhotoPath: any = '';
  pipe = new DatePipe('en-US');
  userEditPhtot = false;
  url: any;
  docmentImage: any = [];
  userDocEditPhtot = false;
  docmentsFiles: any = [];
  array_unit: any = [];
  unitNameSearch = '';
  unitRelation = '';
  accsess_Type: any;
  card_id: any;
  unitSearch_arr: any = [];
  rfid_list: any = [];
  clients_image: any;
  constructor(
    private formBuilder: FormBuilder,
    private activeRouter: ActivatedRoute,
    private route: Router,
    private mainservice: MainService,
    private clientService: ClientsService,
    private location: Location,
    private rest: UnitsService,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.unitId = this.activeRouter.snapshot.params['id'];
    this.clientId = this.activeRouter.snapshot.params['id1'];
    this.initForm();
    this.unitRetalitonType();
    this.retiveClient();
    this.initRfidForm();
    this.accsessType();
  }

  searchUnit(e: any) {
    this.rest.searchunit(this.unitNameSearch).subscribe((res: any) => {
      console.log(res);
      if (res) {
        this.unitSearch_arr = res;
      } else {
        this.unitSearch_arr = [];
      }
    });
  }

  unitIdChoose: any;

  getUnit(value: any) {
    this.unitNameSearch = value.name;
    this.unitIdChoose = value.id;
    this.unitSearch_arr = [];
  }

  addUnit() {
    if (this.unitNameSearch != '' && this.unitRelation != '') {
      let obj = {
        name: this.unitNameSearch,
        relation: this.unitRelation,
        id: this.unitIdChoose
      };
      this.array_unit.push(obj);
      console.log(this.array_unit);
    }
  }

  retiveClient() {
    this.rfid_list = [];
    this.clientService.retiveClient(this.clientId).subscribe((res: any) => {
      console.log(res);

      res.cards.forEach((element: any) => {
        if (element.RFID) {
          this.rfid_list = element.RFID;
          console.log('rfid', true);
        }
      });
      this.clients_image = res.images;
      // this.clients_image.forEach((element: any) => {
      //   element.image = this._sanitizer.bypassSecurityTrustUrl(
      //     `data:image/png;base64,` + element.image
      //   );
      // });
      this.array_unit = res.unit;
      this.typeName = res.type.name
      this.typeId = res.type.id
      this.clientForm.patchValue(res);
    });
  }
  get ControlForm() {
    return this.clientForm.controls;
  }

  initForm() {
    this.clientForm = this.formBuilder.group({
      name: ['', Validators.required],
      valid_from: ['', Validators.required],
      valid_to: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      birth_date: ['', Validators.required],
      gender: ['', Validators.required],
      phone_number: ['', Validators.required],
      verified: [''],
      activated: [''],
      national_id: ['', Validators.required],
      arabic_name: ['', Validators.required]
    });
  }
  initRfidForm() {
    this.RfidForm = this.formBuilder.group({
      front: ['', Validators.required],
      front_source: [''],
      back_source: [''],
      back: ['', Validators.required],
      charOne: ['', Validators.required],
      charTow: ['', Validators.required],
      charThree: ['', Validators.required],
      number: ['', Validators.required],
      // license_plate: ['', Validators.required],
      serial_number: ['', [Validators.required]],
      card_id: ['', [Validators.required]]
    });
  }

  unitRetalitonType() {
    this.rest.unitRelation().subscribe((res: any) => {
      console.log(res);
      this.types_arr = res.children;
    });
  }

  accsessType() {
    this.rest.cardType().subscribe((res: any) => {
      console.log(res);
      res.children.forEach((element: any) => {
        if (element.name == 'RFID') {
          this.accsess_Type = element.id;
        }
      });
    });
  }

  getRelationTypeId(value: any) {
    this.typeName = value.name;
    this.typeId = value.id;
  }
  back() {
    this.location.back();
  }

  editClient() {
    let unitArr: any = [];
    let data = this.clientForm.value;
    data.id = this.clientId;
    data.unit_relation_id = this.typeId
    this.array_unit.forEach((element: any) => {
      unitArr.push({
        unit_id: element.id,
        relation: element.relation
      });
    });
    data.units = unitArr;
    data.birth_date = this.pipe.transform(data.birth_date, 'YYYY-MM-dd');
    console.log(this.clientForm.value);
    this.clientService.editClient(data).subscribe((res: any) => {
      console.log(res);
      this.mainservice.SuccessToast('Edit Client Success');
      this.back();
    });
  }

  deleteUnit(index: any) {
    this.array_unit.splice(index, 1);
    console.log(this.array_unit);
  }

  addRfid() {
    let RfidData = this.RfidForm.value;
    RfidData.number =  Intl.NumberFormat('ar-SA',{
    }).format(RfidData.number);
    RfidData.number = RfidData.number.replace('٬','')
    let data = {
      front: RfidData.front_source,
      back: RfidData.back_source,
      card_id: RfidData.card_id,
      client_id: this.clientId,
      license_plate: RfidData.charThree + ' ' + RfidData.charTow + ' ' +  RfidData.charOne + RfidData.number  ,
      type_id: this.accsess_Type,
      unit_id: this.unitId,
      serial_number: RfidData.serial_number
    };

  

    this.rest
      .addRfid(data)
      .then(response => response.text())
      .then(result => {
        let res = JSON.parse(result);
        if (res.status == true) {
          this.mainservice.SuccessToast('RFID Added');
          this.retiveClient();
        } else {
          this.mainservice.erorrToast('Opss somthing worng happen!');
        }
        console.log(result);
      })
      .catch(error => {
        this.mainservice.erorrToast('Opss somthing worng happen!');
      });

    console.log(data);
  }

  onFileChange(e: any, name: any) {
    const file = e.target.files[0];
    if (name == 'front') {
      this.RfidForm.patchValue({
        front_source: file
      });
    } else {
      this.RfidForm.patchValue({
        back_source: file
      });
    }
  }

  openViewRFID(data: any) {
    this.rest.retriveRfid(data.id).subscribe((res: any) => {
      const dialogRef = this.dialog.open(ViewRfidComponent, {
        width: '400px',
        data: { item: res }
      });
    });

    console.log(data);
  }

  deleteRfid(item: any) {
    const dialogRef = this.dialog.open(DeletRfidComponent, {
      width: '400px',
      data: { item: item }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.rest.deleteRfid(item.id).subscribe((res: any) => {
          this.mainservice.SuccessToast('RFID Deleted');
          this.retiveClient();
        });
      }
    });
  }

  editRFID(item: any) {
    this.rest.retriveRfid(item.id).subscribe((res: any) => {
      const dialogRef = this.dialog.open(EditRFIDComponent, {
        width: '500px',
        data: { item: res }
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.rest
            .editRfid(result)
            .then(response => response.text())
            .then(resu => {
              let res = JSON.parse(resu);
              if (res.status == true) {
                this.mainservice.SuccessToast('RFID Edit success');
                this.retiveClient();
              } else {
                this.mainservice.erorrToast('Opss somthing worng happen!');
              }
              console.log(resu);
            })
            .catch(error => {
              this.mainservice.erorrToast('Opss somthing worng happen!');
            });
        }
      });
    });
  }

  // images
  erorrDocmentPhoto = false;
  uploadDocmentsClient(event: any) {
    this.userDocEditPhtot = true;
    console.log(event.target.files);
    let files: any = event.target.files;
    for (let i = 0; i < files.length; i++) {
      if(this.typeDocName == 'personal_photo'){
        this.docmentsFiles.push({
          type: this.typeDocName ,
          path: files[i]
        });
      }else {
        this.docmentsFiles.push({
          type: this.typeDocName + i,
          path: files[i]
        });
      }
     
      this.convertFile(files[i]);
    }
    console.log(this.docmentImage);
  }

  convertFile(file: any) {
    if (file.type == 'application/pdf') {
      if (this.typeDocName == 'Other') {
        this.typeDocName = this.typeInputName;
      }
      this.docmentImage.push({
        url: file.name,
        file: true,
        fileName: file.name,
        name: this.typeDocName
      });
    } else {
      if (this.typeDocName == 'Other') {
        this.typeDocName = this.typeInputName;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = _event => {
        this.docmentImage.push({
          url: reader.result,
          file: false,
          fileName: file.name,
          name: this.typeDocName
        });
      };
    }
    this.erorrDocmentPhoto = false;
  }

  removeDocImage(item: any) {
    console.log(item);
    for (let i = 0; i < this.docmentImage.length; i++) {
      if (this.docmentImage[i].fileName == item.fileName) {
        this.docmentImage.splice(i, 1);
      }
    }
    for (let i = 0; i < this.docmentsFiles.length; i++) {
      console.log(this.docmentsFiles[i]);
      if (this.docmentsFiles[i].path.name == item.fileName) {
        console.log(this.docmentsFiles[i]);
        this.docmentsFiles.splice(i, 1);
      }
    }
    if (this.docmentsFiles.length == 0) {
      this.userDocEditPhtot = false;
      this.erorrDocmentPhoto = true;
    }

    console.log(this.docmentsFiles);
  }

  typeDocName: any = 'personal_photo';
  typeInputName: any = '';
  status_input_type_name = false;
  typechoose(e: any) {
    if (e == 'Other') {
      this.status_input_type_name = true;
    } else {
      this.status_input_type_name = false;
      this.typeDocName = e;
    }
  }

  showInputFile = false;
  addImage() {
    this.showInputFile = true;
  }

  createImage() {
    this.rest
      .addClientImage(this.clientId, this.docmentsFiles)
      .then((response: any) => response.text())
      .then((result: any) => {
        this.mainservice.SuccessToast('Image updated');
        // this.back();
        this.docmentsFiles = []
        this.docmentImage = []
        this.showInputFile = false
        this.status_input_type_name = false
        this.typeDocName = 'personal_photo';
        this.retiveClient()
        console.log(result);
      })
      .catch((error: any) => {});
  }

  deletImage(id:any){
    this.rest.deletClientImage(id).subscribe((res:any) => {
      console.log(res)
      this.retiveClient()
      this.mainservice.SuccessToast('Image Deleted');
    })
  }

  inputChange(e:any){
    console.log(e.target.value)
    this.typeDocName = e.target.value
  }
}
